import { useState } from "react";
import Header from "./Header";
import { useLocation } from "react-router-dom";

function UpdateImage() {
  const location = useLocation();
  const { profile } = location.state || {};

  const [formData, setFormData] = useState({
    mobile: profile?.mobile || "",
  });

  const [originalData] = useState(formData);
  const [images, setImages] = useState(profile?.images || []);

  const toggleVerification = (index) => {
    const updated = [...images];
    updated[index].verified = !updated[index].verified;
    setImages(updated);
  };

  const getChangedFields = () => {
    const changed = {};

    for (const key in formData) {
      if (formData[key] !== originalData[key]) {
        changed[key] = formData[key];
      }
    }

    changed.mobile = formData.mobile;
    changed.images = images;
    return changed;
  };

  const deleteImage = (index) => {
    const updated = images.filter((_, i) => i !== index);
    setImages(updated);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = getChangedFields();

    if (Object.keys(payload).length === 0) {
      alert("No changes detected.");
      return;
    }

    try {
      const token = localStorage.getItem("token");
      const res = await fetch(
        "https://xqk5c9abna.execute-api.ap-south-1.amazonaws.com/prod/profile/EditProfile",
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify(payload),
        }
      );

      if (res.ok) {
        window.history.back();
      } else {
        const err = await res.json();
        alert("Error: " + err.message);
      }
    } catch (error) {
      console.error("Update failed:", error);
      alert("Something went wrong.");
    }
  };

  return (
    <>
      <Header />
      <div className="container py-3">
        <h3 className="m-0 lh-sm">
          Update Image &mdash; {profile?.name || "User"}{" "}
          <span className="text-secondary">({profile?.userId})</span>
        </h3>
        <p className="mb-5 text-danger">
          🖼️ Profile Photo Verification, Mark images as verified if appropriate
        </p>

        <form
          onSubmit={handleSubmit}
          className="col-lg-7 col-12 row g-2 bg-light p-4 rounded-4"
        >
          <div className="col-12 mb-4">
            <div className="row g-3">
              {images.map((img, index) => (
                <div className="col-md-4" key={index}>
                  <div
                    className="card shadow-sm rounded-4"
                    style={{
                      backgroundImage: `url(${img.docUrl})`,
                      backgroundPosition: "center",
                    }}
                  >
                    <img
                      src={img.docUrl}
                      alt={`Image ${index + 1}`}
                      className="card-img-top object-fit-contain rounded-top-4"
                      height="250"
                    />
                    <div className="py-3 px-3 text-center bg-white rounded-bottom-4">
                      <button
                        type="button"
                        onClick={() => toggleVerification(index)}
                        className={`btn btn-sm rounded-pill ${
                          img.verified ? "btn-success" : "btn-outline-danger"
                        }`}
                      >
                        {img.verified ? "Verified" : "Mark as Verified"}
                      </button>
                      <button
                        type="button"
                        onClick={() => deleteImage(index)}
                        className="btn btn-sm btn-outline-dark rounded-pill ms-1"
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="col-12 d-flex justify-content-center">
            <button
              type="submit"
              className="btn btn-primary rounded-pill mt-2 px-5"
            >
              Save Changes
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default UpdateImage;
